module.exports = __webpack_public_path__ + "img/GH-kyujin-top-009.d7154dac.webp";